import { render, staticRenderFns } from "./AccountSettingsView.vue?vue&type=template&id=0d1b63f1&"
import script from "./AccountSettingsView.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports